import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '../../../../core/services/config.service';
import { fuseAnimations } from '../../../../core/animations';
import { UserService } from '../../services/user.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { FuseConfirmDialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { Login } from '../../models/user.model';
import { AppService } from '../../services/app.service';
import { ComponentService } from '../../services/component.service';
import { SystemDataService } from '../../services/systemdata.service';
import { MaintainanceComponent } from '../maintainance/maintainance.component';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: fuseAnimations
})
export class LoginComponent implements OnInit {
  formGroup: FormGroup;
  formGroupErrors: any;
  user = new Login();
  translations: any = [];
  versionDetails: any = [];
  maintainanaceData : {
    MaintainanceActivity: "",
    MaintenanceMessage :  "",
    ShowMaintenanceMessage : ""
  };
  editFormDialogRef: MatDialogRef<MaintainanceComponent>;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  disabledForm : boolean = false;;
  constructor(
    private userService: UserService,
    private fuseConfig: FuseConfigService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public _router: Router,
    public appService :AppService,
    public comService :ComponentService,
    public sysService : SystemDataService
  ) {

     
     this.fuseConfig.setSettings({
      layout: {
        navigation: 'none',
        toolbar: 'none',
        footer: 'none'
      }
    });

    this.formGroupErrors = {
      Username: {},
      Password: {}
    };

    this.formGroup = this.formBuilder.group({
      Username: ['', Validators.required],
      Password: ['', Validators.required]
    });
  }
  ngOnInit() {
    // if (sessionStorage.getItem('authToken') != null) {
    //   this._router.navigateByUrl('/dashboard')
    // }
this.loadPage();
    this.checkMaintainance();

    
  }

  loadPage(){
    this.fuseConfig.setSettings({
      layout: {
        navigation: 'none',
        toolbar: 'none',
        footer: 'none'
      }
    });
    this.formGroup.valueChanges.subscribe(() => {
      this.formGroupErrors = this.appService.onFormValuesChanged(this.formGroup, this.formGroupErrors);
    });
    if(this.translations.length <= 0){
    this.comService.get('login').subscribe((res) => {
      this.translations = JSON.parse(res['Data']);   
       this.comService.getVersionDetails().subscribe((res) => {
          this.versionDetails = JSON.parse(res['Data']);
          this.appService.hideLoading();
        });
    });   
  }

  }
  checkMaintainance(){
    this.sysService.maintainancecheck().subscribe(
      res=> this.checkMaintainanceSuccess(res),
      error=>this.checkMaintainanceFailure(error)
    )
  }
  checkMaintainanceSuccess(res){
    if(res.Status == 1){
      
      this.maintainanaceData= JSON.parse(res.Data)[0];
      
      if(this.maintainanaceData.MaintainanceActivity.toString() == '1'){
        if(this.maintainanaceData.ShowMaintenanceMessage.toString() == '1'){
          this.editFormDialogRef = this.dialog.open(MaintainanceComponent, {
            disableClose: true,
            data: {
              MaintenanceMessage : this.maintainanaceData.MaintenanceMessage
            },
            panelClass: 'my-dialog'
          });
          this.editFormDialogRef.afterClosed().subscribe((response) => {
            this.loadPage();
          });
        }
        else{
          this.disabledForm = true;
          
        }
       
      }
      else{
        if(this.maintainanaceData.ShowMaintenanceMessage.toString() == '1'){
          this.editFormDialogRef = this.dialog.open(MaintainanceComponent, {
            disableClose: true,
            data: {
              MaintenanceMessage : this.maintainanaceData.MaintenanceMessage
            },
            panelClass: 'my-dialog'
          });         
        }
        else{
          this.disabledForm = false;
        }
        
      }
    }

  }
  checkMaintainanceFailure(error){

  }
  apiFailure(error): void {
    sessionStorage.setItem('pageData', "");
    this.appService.hideLoading();
  }

  setPageTranslations(){
     
  }  

  login(): void {
    this.appService.showLoading();
    this.userService.authenticate(this.user).subscribe(
      res => this.loginSuccessCallback(res),
      error => this.loginErrorCallback(error)
    );
  }

  loginSuccessCallback(res): void {
    this.appService.hideLoading();
    if (res['Status'] == '1') {
      sessionStorage.setItem('authToken', JSON.parse(res["Data"])[0]["Token"]);
      sessionStorage.setItem('pageList',res["Data"]);
      this.setDashboardTileOrderListUrl(JSON.parse(res["Data"]));
      sessionStorage.setItem('timeoutShown', '0');
      this._router.navigateByUrl('/dashboard');
    }
    else {
      this.loginErrorCallback(this.translations[res.Message])
    }
  }

  loginErrorCallback(error): void {
    this.appService.showDialogue(this.translations["loginDialogHeader"], error);
  }

  setDashboardTileOrderListUrl(arr){
    var urlAssigned = false;
    for(var i = 0; i < arr.length; i++){
      if(arr[i].Url == '/order'){
        urlAssigned = true;
      }
    }
    var url = urlAssigned ? '/order' : '/distorder';
    sessionStorage.setItem('dashboardTileOrderListUrl', url); 
  }

}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/login/login.component.ts